export default __webpack_public_path__ + "static/media/logo.eb961008.png";